export const KY_PHONE = '+82 02-6105-7550';
export const KY_EMAIL = 'support@kyentertainment.kr';
export const KY_CORP_NUMBER = '221-88-00319';
export const KY_KARAOKE_NAME = 'K-araoke';
export const KY_SERVICE_NAME = 'KYoung PAY';
export const KY_BIXBY_NAME = '금영 노래방';

export const KY_PREFIX_KARAOKE = 'TV';
export const KY_PREFIX_BIXBY = 'Bixby';
